<div class="mat-elevation-z8">
  <table mat-table class="stripped-table" #fundParticipantsTable
         #dataSort="matSort" [dataSource]="dataSource" matSort>

    <!-- Role Column -->
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
      <td mat-cell class="name-column" *matCellDef="let row"> {{row.role}} </td>
    </ng-container>

    <!-- Participant Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
      <td mat-cell *matCellDef="let row">
        <a href="{{row.url}}" target="_blank">{{row.name}}</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="dataColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: dataColumns;"></tr>
  </table>
</div>
